import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";
import { CSVLink } from "react-csv";
import { headers } from "./headers";
import VirtualTable from "../VirtualTable";

import {
  Row,
  Col,
  Form,
  Table,
  Button,
  Input,
  Space,
  Select,
  DatePicker,
  Spin,
  Radio,
  Typography,
  Modal,
  Checkbox,
} from "antd";

import { EyeOutlined, RedoOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import dayjs from "dayjs";

import FloatLabel from "../FloatLabel";
import GrandLivrePDF from "../Pdf/Comptabilite/GrandLivrePDF";
import Operation from "../../containers/Comptabilite/Operation";
import ComptePDF from "../Pdf/Comptabilite/ComptePDF";
import FormItem from "antd/lib/form/FormItem";

import { HttpMethod, initFetch } from "../../utils/fetcher";
import { isLigneReportNul } from "../../utils/tools";
import PdfReaderModal from "../modals/PdfReaderModal";

const dateFormat = "DD/MM/YYYY";

const { Text } = Typography;
const { Option, OptGroup } = Select;

class FormGrandLivre extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      refresh: false,
      idFirstCompte: null,
      idLastCompte: null,
      ecritureState: null,
      lignesEcritures: [],
      modalEcriture: false,
      modalPdfReader: false,
      pdfUrl: null,
      pdfReaderTitle: null,
      searchText: "",
      searchedColumn: "",
      compteCentralisateur: null,
      compteDu: null,
      compteAu: null,
      dateDu: null,
      dateAu: dayjs().startOf("day"),
      sortedInfo: null,
      soldeEvolutif: false,
      ecrituresPointees: true,
      tri: 1,
      scrollVersion: 0, // Nouvelle prop pour contrôler le scroll
    };
  }

  // Référence du formulaire
  formRef = React.createRef();

  // Méthode pour incrémenter la version de scroll (déclenche le scroll)
  triggerScroll = () => {
    this.setState(prevState => ({ scrollVersion: prevState.scrollVersion + 1 }));
  };

  componentDidMount() {
    this.props.grandLivre
      ? this.initComptesAuxiliaire(this.props.comptes.data, this.state.compteCentralisateur)
      : this.initSociete();
  }

  componentWillUnmount() {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl);
    }
  }

  init = () => {
    let lignesEcritures = [];
    let lignesCentralisateurs = [];
    let ecrituresFiltered = this.props.ecritures;

    if (this.state.dateDu)
      ecrituresFiltered = ecrituresFiltered.filter((e) =>
        dayjs(e.ecriture_date_ecriture, "DD/MM/YYYY").isSameOrAfter(this.state.dateDu)
      );
    if (this.state.dateAu)
      ecrituresFiltered = ecrituresFiltered.filter((e) =>
        dayjs(e.ecriture_date_ecriture, "DD/MM/YYYY").isSameOrBefore(this.state.dateAu)
      );

    ecrituresFiltered &&
    ecrituresFiltered.forEach((ecriture) => {
      let lignes = [];
      if (this.state.compteCentralisateur) {
        lignes = ecriture.ecriture_ligne.filter(
          (e) =>
            e.ecriture_ligne_compte.compte_compte_auxiliaire >= this.state.compteDu &&
            e.ecriture_ligne_compte.compte_compte_auxiliaire <= this.state.compteAu &&
            e.ecriture_ligne_compte.compte_compte_general ===
            this.props.comptes.data.find(
              (compte) => compte.compte_id === this.state.compteCentralisateur
            ).compte_compte_general
        );
      } else {
        lignes = ecriture.ecriture_ligne.filter(
          (e) =>
            e.ecriture_ligne_compte.compte_compte_general >= this.state.compteDu &&
            e.ecriture_ligne_compte.compte_compte_general <= this.state.compteAu &&
            e.ecriture_ligne_compte.compte_type_compte !== "A"
        );
      }

      lignes &&
      lignes.forEach((ligne) => {
        ligne.ecriture_id = ecriture.ecriture_id;
        ligne.ecriture_journal_code = ecriture.ecriture_journal.journal_code;
        ligne.ecriture_date_ecriture = ecriture.ecriture_date_ecriture;
        if (this.isReglementReddition(ecriture)) ligne.ecriture_ligne_en_reddition = true;
        lignesEcritures.push(ligne);
      });
    });

    // Comptes centralisateurs
    if (this.props.grandLivre && !this.state.compteCentralisateur) {
      this.props.comptes.data
        .filter((item) => item.compte_type_compte === "C")
        .forEach((compte) => {
          let totalDebit = 0;
          let totalCredit = 0;

          ecrituresFiltered &&
          ecrituresFiltered.forEach((ecriture) => {
            let lignesCentralisateur = ecriture.ecriture_ligne.filter(
              (e) =>
                e.ecriture_ligne_compte.compte_compte_general === compte.compte_compte_general
            );

            lignesCentralisateur.forEach((ligne) => {
              totalDebit += parseFloat(ligne.ecriture_ligne_montant_debit);
              totalCredit += parseFloat(ligne.ecriture_ligne_montant_credit);
            });
          });

          const ligneCentralisateur = {
            ecriture_ligne_id: compte.compte_compte_general,
            ecriture_id: "",
            ecriture_date_ecriture: "",
            ecriture_ligne_compte: compte,
            ecriture_ligne_libelle: compte.compte_libelle,
            ecriture_journal_code: "",
            ecriture_ligne_montant_debit: totalDebit,
            ecriture_ligne_montant_credit: totalCredit,
            solde: "",
          };
          lignesCentralisateurs.push(ligneCentralisateur);
        });
    }

    lignesEcritures.sort(
      (a, b) =>
        dayjs(a.ecriture_date_ecriture, "DD/MM/YYYY").unix() -
        dayjs(b.ecriture_date_ecriture, "DD/MM/YYYY").unix()
    );

    const comptesFiltered = this.filterByCompte(
      this.props.comptes.data,
      this.state.compteCentralisateur
    );
    const compteDu =
      comptesFiltered.length > 0
        ? this.state.compteCentralisateur
          ? comptesFiltered[0].compte_compte_auxiliaire
          : comptesFiltered[0].compte_compte_general
        : null;
    const compteAu =
      comptesFiltered.length > 0
        ? this.state.compteCentralisateur
          ? comptesFiltered[comptesFiltered.length - 1].compte_compte_auxiliaire
          : comptesFiltered[comptesFiltered.length - 1].compte_compte_general
        : null;
    const pleinePlage = compteDu === this.state.compteDu && compteAu === this.state.compteAu;
    const lignesReport = this.initLignesReport(lignesEcritures, lignesCentralisateurs, pleinePlage);

    if (pleinePlage) lignesEcritures = lignesCentralisateurs.concat(lignesEcritures);
    lignesEcritures = lignesReport.concat(lignesEcritures);

    // Solde évolutif : part du report
    let solde = 0;
    lignesEcritures = lignesEcritures
      // .sort((a, b) => a.ecriture_ligne_id - b.ecriture_ligne_id)
      .map((ligne) => {
        solde += parseFloat(
          ligne.ecriture_ligne_montant_debit - ligne.ecriture_ligne_montant_credit
        );
        ligne.solde = solde;
        return ligne;
      });

    if (!this.state.ecrituresPointees)
      lignesEcritures = lignesEcritures.filter(
        (ligne) =>
          ligne.ecriture_ligne_lettrage === "" ||
          ligne.ecriture_ligne_lettrage === undefined ||
          ligne.ecriture_ligne_lettrage === null ||
          ligne.ecriture_ligne_report
      );

    this.setState({ lignesEcritures, refresh: false });
  };

  // Solde de report par compte_id : report API (antérieur à la période chargée)
  // + lignes chargées antérieures à « Du » (« Du » borné à l'exercice, donc dans la période)
  calculerReports = () => {
    const reports = new Map();
    const ajouter = (compteId, montant) =>
      reports.set(compteId, (reports.get(compteId) || 0) + montant);

    (this.props.report || []).forEach((report) =>
      ajouter(report.compte_id, parseFloat(report.montant_debit) - parseFloat(report.montant_credit))
    );

    if (this.state.dateDu)
      this.props.ecritures
        .filter((e) => dayjs(e.ecriture_date_ecriture, "DD/MM/YYYY").isBefore(this.state.dateDu))
        .forEach((ecriture) =>
          ecriture.ecriture_ligne.forEach((ligne) =>
            ajouter(
              ligne.ecriture_ligne_compte_id,
              parseFloat(ligne.ecriture_ligne_montant_debit) -
                parseFloat(ligne.ecriture_ligne_montant_credit)
            )
          )
        );

    return reports;
  };

  // Année de début de la période chargée (non renvoyée par l'API, règle de EcritureController::index) :
  // l'année précédente tant que l'on est à moins de 90 jours du 01/01 de l'exercice
  anneeDebutPeriode = () => {
    const { annee } = this.props;
    return dayjs().isBefore(dayjs(`${annee}-01-01`).add(90, "day")) ? annee - 1 : annee;
  };

  creerLigneReport = (compte, montant) => {
    const solde = Math.round(montant * 100) / 100;
    return {
      ecriture_ligne_id: `report-${compte.compte_id}`,
      ecriture_id: "",
      // Toujours daté du début de la période chargée, quel que soit « Du » (le montant, lui, est arrêté à « Du »)
      ecriture_date_ecriture: `01/01/${this.anneeDebutPeriode()}`,
      ecriture_ligne_compte: compte,
      ecriture_ligne_compte_id: compte.compte_id, // regroupement par compte de ComptePDF
      ecriture_ligne_libelle: "SOLDE DE REPORT",
      ecriture_journal_code: "",
      ecriture_ligne_montant_debit: solde > 0 ? solde : 0,
      ecriture_ligne_montant_credit: solde < 0 ? -solde : 0,
      ecriture_ligne_report: true,
    };
  };

  // Une ligne de report par compte (en tête, ordre des comptes) :
  // - auxiliaire : par auxiliaire de la plage ;
  // - général : par compte G de la plage + par centralisateur (cumul de ses auxiliaires) en pleine plage, comme les lignes de synthèse.
  // Un report nul n'est affiché que si le compte a des mouvements sur la période (toujours en interrogation de compte).
  initLignesReport = (lignesEcritures, lignesCentralisateurs, pleinePlage) => {
    const { compteCentralisateur, compteDu, compteAu } = this.state;
    const comptes = this.props.comptes.data;
    const reports = this.calculerReports();
    const comptesMouvementes = new Set(lignesEcritures.map((l) => l.ecriture_ligne_compte_id));
    const lignesReport = [];

    const ajouterSiPertinent = (compte, montant, mouvemente) => {
      if (Math.round(montant * 100) !== 0 || mouvemente || !this.props.grandLivre)
        lignesReport.push(this.creerLigneReport(compte, montant));
    };

    if (compteCentralisateur) {
      const cptGen = comptes.find((c) => c.compte_id === compteCentralisateur).compte_compte_general;
      comptes
        .filter(
          (c) =>
            c.compte_type_compte === "A" &&
            c.compte_compte_general === cptGen &&
            c.compte_compte_auxiliaire >= compteDu &&
            c.compte_compte_auxiliaire <= compteAu
        )
        .forEach((c) =>
          ajouterSiPertinent(c, reports.get(c.compte_id) || 0, comptesMouvementes.has(c.compte_id))
        );

      return lignesReport.sort((a, b) =>
        a.ecriture_ligne_compte.compte_compte_auxiliaire.localeCompare(
          b.ecriture_ligne_compte.compte_compte_auxiliaire
        )
      );
    }

    comptes
      .filter(
        (c) =>
          c.compte_type_compte === "G" &&
          c.compte_compte_general >= compteDu &&
          c.compte_compte_general <= compteAu
      )
      .forEach((c) =>
        ajouterSiPertinent(c, reports.get(c.compte_id) || 0, comptesMouvementes.has(c.compte_id))
      );

    if (this.props.grandLivre && pleinePlage)
      lignesCentralisateurs.forEach((synthese) => {
        const centralisateur = synthese.ecriture_ligne_compte;
        const montant = comptes
          .filter((c) => c.compte_compte_general === centralisateur.compte_compte_general)
          .reduce((total, c) => total + (reports.get(c.compte_id) || 0), 0);
        const mouvemente =
          synthese.ecriture_ligne_montant_debit !== 0 || synthese.ecriture_ligne_montant_credit !== 0;
        ajouterSiPertinent(centralisateur, montant, mouvemente);
      });

    return lignesReport.sort((a, b) =>
      a.ecriture_ligne_compte.compte_compte_general.localeCompare(
        b.ecriture_ligne_compte.compte_compte_general
      )
    );
  };

  isReglementReddition = (ecriture) => {
    const match = ecriture.ecriture_action?.match(/^REG(\d+)$/);
    const result = match ? match[1] : null; // Si la correspondance est trouvée, renvoie le numéro, sinon renvoie null
    return this.props.reglements.some(
      (reg) => reg.reglement_id === parseInt(result) && reg.reglement_reddition
    );
  };

  initComptesAuxiliaire = (comptes, compteCentralisateur) => {
    const comptesFiltered = this.filterByCompte(comptes, compteCentralisateur);

    this.formRef.current.setFieldsValue({
      compteDu:
        comptesFiltered.length > 0
          ? compteCentralisateur
            ? comptesFiltered[0].compte_compte_auxiliaire
            : comptesFiltered[0].compte_compte_general
          : null,
      compteAu:
        comptesFiltered.length > 0
          ? compteCentralisateur
            ? comptesFiltered[comptesFiltered.length - 1].compte_compte_auxiliaire
            : comptesFiltered[comptesFiltered.length - 1].compte_compte_general
          : null,
      ecrituresPointees: true,
    });
    this.setState({
      compteDu:
        comptesFiltered.length > 0
          ? compteCentralisateur
            ? comptesFiltered[0].compte_compte_auxiliaire
            : comptesFiltered[0].compte_compte_general
          : null,
      compteAu:
        comptesFiltered.length > 0
          ? compteCentralisateur
            ? comptesFiltered[comptesFiltered.length - 1].compte_compte_auxiliaire
            : comptesFiltered[comptesFiltered.length - 1].compte_compte_general
          : null,
    }, () => {
      this.triggerScroll(); // Déclencher le scroll lors de l'initialisation
    });
  };

  initSociete = () => {
    this.formRef.current.setFieldsValue({
      ecrituresPointees: true,
    });
    this.triggerScroll(); // Déclencher le scroll lors de l'initialisation
  };

  filterByCompte = (comptes, compteCentralisateur) => {
    if (comptes === undefined) return [];
    let comptesFiltered = [];
    compteCentralisateur
      ? (comptesFiltered = comptes.filter(
        (item) =>
          item.compte_compte_general ===
          comptes.find((item) => item.compte_id === compteCentralisateur)
            .compte_compte_general && item.compte_type_compte === "A"
      ))
      : (comptesFiltered = comptes.filter((item) => item.compte_type_compte === "G"));
    return compteCentralisateur
      ? comptesFiltered.sort((a, b) =>
        a.compte_compte_auxiliaire.localeCompare(b.compte_compte_auxiliaire)
      )
      : comptesFiltered.sort((a, b) =>
        a.compte_compte_general.localeCompare(b.compte_compte_general)
      );
  };

  onChangeCompteCentralisateur = (idCompte) => {
    this.formRef.current.setFieldsValue({
      compteDu: null,
      compteAu: null,
    });
    this.initComptesAuxiliaire(this.props.comptes.data, idCompte);
    this.setState({ compteCentralisateur: idCompte }, () => {
      this.triggerScroll(); // Déclencher le scroll lors du changement de compte centralisateur
    });
  };

  onSelectCompteDu = (idCompte) => {
    this.formRef.current.setFieldsValue({
      compteAu: idCompte,
    });
    this.setState({ compteDu: idCompte, compteAu: idCompte }, () => {
      this.onRefresh();
      this.triggerScroll(); // Déclencher le scroll lors de la sélection de compte
    });
  };

  onSelectCompteAu = (idCompte) => {
    this.setState({ compteAu: idCompte }, () => {
      this.triggerScroll(); // Déclencher le scroll lors de la sélection de compte
    });
  };

  onChangeDateDu = (dateDu) => {
    const normalizedDate = dayjs(dateDu).startOf("day");
    this.setState({ dateDu: normalizedDate }, () => {
      this.triggerScroll(); // Déclencher le scroll lors du changement de date
    });
  };

  onChangeDateAu = (dateAu) => {
    this.setState({ dateAu }, () => {
      this.triggerScroll(); // Déclencher le scroll lors du changement de date
    });
  };

  onRefresh = () => {
    this.setState({ refresh: true }, () => {
      this.init();
      this.triggerScroll(); // Déclencher le scroll lors du rafraîchissement
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Rechercher ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Rechercher
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : "",
    filterDropdownProps: {
      onOpenChange: (open) => {
        if (open) {
          setTimeout(() => this.searchInput?.select(), 100);
        }
      },
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  // Pas de scroll pour la recherche
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
    // Pas de triggerScroll() ici - recherche dans les colonnes
  };

  // Pas de scroll pour le reset de recherche
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
    // Pas de triggerScroll() ici - reset de recherche
  };

  createPdf = () => {
    const html = ReactDOMServer.renderToStaticMarkup(
      <GrandLivrePDF
        lignesEcritures={this.state.lignesEcritures}
        dateDu={this.state.dateDu}
        dateAu={this.state.dateAu}
        compteCentralisateur={this.state.compteCentralisateur}
        compteDu={this.state.compteDu}
        compteAu={this.state.compteAu}
        comptes={this.props.comptes.data}
        soldeEvolutif={this.state.soldeEvolutif}
        tri={this.state.tri}
      />
    );
    const pdf = {
      titre: "Grand Livre",
      destinataire: "",
      pdf_page: [],
    };
    const pdfPage = {
      html: html,
    };
    pdf.pdf_page.push(pdfPage);
    const { url, params } = initFetch(`pdfs`, HttpMethod.POST);
    fetch(url, { ...params, body: JSON.stringify(pdf) })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (result) {
          this.openPdfReader(result.pdf.id, "a", "Grand Livre");
        }.bind(this)
      );
  };

  createPdf2 = () => {
    const html = ReactDOMServer.renderToStaticMarkup(
      <ComptePDF
        lignesEcritures={this.state.lignesEcritures}
        dateDu={this.state.dateDu}
        dateAu={this.state.dateAu}
        compteCentralisateur={this.state.compteCentralisateur}
        compteDu={this.state.compteDu}
        compteAu={this.state.compteAu}
        comptes={this.props.comptes.data}
        soldeEvolutif={this.state.soldeEvolutif}
      />
    );
    const pdf = {
      titre: "Compte",
      destinataire: "",
      pdf_page: [],
    };
    const pdfPage = {
      html: html,
    };
    pdf.pdf_page.push(pdfPage);
    const { url, params } = initFetch(`pdfs`, HttpMethod.POST);
    fetch(url, { ...params, body: JSON.stringify(pdf) })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (result) {
          this.openPdfReader(result.pdf.id, "a", "Compte");
        }.bind(this)
      );
  };

  getFileFromUrl = (id, type = "a") => {
    const { url, params } = initFetch(`api/v1/pdfs/${id}/render/${type}`, HttpMethod.GET, {
      Authorization: true,
      formData: false,
      pdf: true,
    });
    return fetch(url, params).then((response) => response.blob());
  };

  openPdfReader = (id, type, title) => {
    this.getFileFromUrl(id, type).then((blob) => {
      this.setState({
        pdfUrl: URL.createObjectURL(blob),
        pdfReaderTitle: title,
        modalPdfReader: true,
      });
    });
  };

  closePdfReader = () => {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl);
    }
    this.setState({ modalPdfReader: false, pdfUrl: null, pdfReaderTitle: null });
  };

  // Pas de scroll pour la visualisation
  handleClickVisualisation = (id) => {
    const ecriture = this.props.ecritures.find((ecriture) => ecriture.ecriture_id === id);
    this.setState({ ecritureState: ecriture, modalEcriture: true });
    // Pas de triggerScroll() ici - visualisation d'écriture
  };

  closeModalEcriture = () => {
    this.setState({ modalEcriture: false });
  };

  onChangeSoldeEvolutif = () => {
    let sortedInfo = this.state.sortedInfo;
    if (!this.state.soldeEvolutif) {
      sortedInfo = {
        order: "ascend",
        columnKey: "ecriture_date_ecriture",
      };
    }
    this.setState({ soldeEvolutif: !this.state.soldeEvolutif, sortedInfo }, () => {
      this.triggerScroll(); // Déclencher le scroll lors du changement de solde évolutif
    });
  };

  onChangeEcrituresPointees = () => {
    this.setState({ ecrituresPointees: !this.state.ecrituresPointees }, () => {
      this.init();
      this.triggerScroll(); // Déclencher le scroll lors du changement du filtre écritures pointées
    });
  };

  // Pas de scroll pour le tri des colonnes
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter,
    });
    // Pas de triggerScroll() ici - tri des colonnes
  };

  onChangeTri = (e) => {
    this.setState({ tri: e.target.value }, () => {
      this.triggerScroll(); // Déclencher le scroll lors du changement de tri
    });
  };

  render() {
    const {
      loading,
      refresh,
      ecritureState,
      lignesEcritures,
      modalEcriture,
      modalPdfReader,
      pdfUrl,
      pdfReaderTitle,
      compteCentralisateur,
      compteDu,
      compteAu,
      dateDu,
      dateAu,
      sortedInfo,
      soldeEvolutif,
      tri,
      scrollVersion, // Nouvelle prop
    } = this.state;
    const { comptes, grandLivre, annee } = this.props;

    let columns = [
      {
        title: "Compte Général",
        dataIndex: "ecriture_ligne_compte",
        key: "ecriture_ligne_compte",
        render: (compte) => (compte ? compte.compte_compte_general : ""),
        align: "left",
        width: 140,
      },
      {
        title: "Compte Auxliaire",
        dataIndex: "ecriture_ligne_compte",
        key: "ecriture_ligne_compte",
        render: (compte) => (compte ? compte.compte_compte_auxiliaire : ""),
        align: "left",
        width: 150,
      },
      {
        title: "N°Ecriture",
        dataIndex: "ecriture_id",
        key: "ecriture_id",
        align: "left",
        width: 100,
      },
      {
        title: "Date",
        dataIndex: "ecriture_date_ecriture",
        key: "ecriture_date_ecriture",
        sorter: (a, b) =>
          dayjs(a.ecriture_date_ecriture, "DD/MM/YYYY").unix() -
          dayjs(b.ecriture_date_ecriture, "DD/MM/YYYY").unix(),
        sortOrder:
          sortedInfo &&
          !soldeEvolutif &&
          sortedInfo.columnKey === "ecriture_date_ecriture" &&
          sortedInfo.order,
        width: 120,
      },
      {
        title: "Libellé",
        dataIndex: "ecriture_ligne_libelle",
        key: "ecriture_ligne_libelle",
        ...this.getColumnSearchProps("ecriture_ligne_libelle"),
      },
      {
        title: "Jrn",
        dataIndex: "ecriture_journal_code",
        key: "ecriture_journal_code",
        align: "right",
        width: 80,
      },
      {
        title: "Montant Débit",
        dataIndex: "ecriture_ligne_montant_debit",
        key: "ecriture_ligne_montant_debit",
        ...this.getColumnSearchProps("ecriture_ligne_montant_debit"),
        render: (montant, ligne) =>
          parseFloat(montant) !== 0 || isLigneReportNul(ligne) ? (
            parseFloat(montant).toLocaleString("fr-FR", {
              style: "currency",
              currency: "EUR",
            })
          ) : (
            <></>
          ),
        className: "column-money",
        align: "right",
        ...(!soldeEvolutif && {
          sorter: (a, b) => a.ecriture_ligne_montant_debit - b.ecriture_ligne_montant_debit,
        }),
        sortOrder:
          sortedInfo && sortedInfo.columnKey === "ecriture_ligne_montant_debit" && sortedInfo.order,
        width: 200,
      },
      {
        title: "Montant Crédit",
        dataIndex: "ecriture_ligne_montant_credit",
        key: "ecriture_ligne_montant_credit",
        ...this.getColumnSearchProps("ecriture_ligne_montant_credit"),
        render: (montant, ligne) =>
          parseFloat(montant) !== 0 || isLigneReportNul(ligne) ? (
            parseFloat(montant).toLocaleString("fr-FR", {
              style: "currency",
              currency: "EUR",
            })
          ) : (
            <></>
          ),
        className: "column-money",
        align: "right",
        ...(!soldeEvolutif && {
          sorter: (a, b) => a.ecriture_ligne_montant_debit - b.ecriture_ligne_montant_debit,
        }),
        sortOrder:
          sortedInfo &&
          sortedInfo.columnKey === "ecriture_ligne_montant_credit" &&
          sortedInfo.order,
        width: 200,
      },
      {
        title: "Solde évolutif",
        dataIndex: "solde",
        key: "solde",
        render: (solde) =>
          soldeEvolutif ? (
            parseFloat(solde).toLocaleString("fr-FR", {
              style: "currency",
              currency: "EUR",
            })
          ) : (
            <></>
          ),
        align: "right",
        width: 120,
      },
      {
        title: "Pointage",
        dataIndex: "ecriture_ligne_lettrage",
        key: "ecriture_ligne_lettrage",
        ...this.getColumnSearchProps("ecriture_ligne_lettrage"),
        ...(!soldeEvolutif && {
          sorter: (a, b) =>
            a.ecriture_ligne_lettrage &&
            a.ecriture_ligne_lettrage.localeCompare(b.ecriture_ligne_lettrage),
        }),
        sortOrder:
          sortedInfo && sortedInfo.columnKey === "ecriture_ligne_lettrage" && sortedInfo.order,
        align: "right",
        width: 130,
      },
      {
        title: "Reddition",
        dataIndex: "ecriture_ligne_en_reddition",
        key: "ecriture_ligne_en_reddition",
        render: (reddition) => (reddition ? "*" : ""),
        align: "right",
        width: 120,
      },
      {
        title: "Visualisation",
        dataIndex: "ecriture_id",
        key: "ecriture_id",
        render: (ecriture_id) => (
          <Button onClick={() => this.handleClickVisualisation(ecriture_id)}>
            <EyeOutlined />
          </Button>
        ),
        width: 150,
      },
    ];

    return (
      <Spin spinning={loading} size="large" tip="Chargement...">
        <PdfReaderModal
          open={modalPdfReader}
          onCancel={this.closePdfReader}
          pdfUrl={pdfUrl}
          title={pdfReaderTitle}
        />

        <Modal
          footer={null}
          title="Visualisation"
          width={1200}
          open={modalEcriture}
          onCancel={this.closeModalEcriture}
        >
          {ecritureState && (
            <Operation edit={true} readOnly={false} ecritureProps={ecritureState} />
          )}
        </Modal>

        <Form ref={this.formRef} size="large" style={{ padding: 20 }}>
          <Row gutter={12}>
            <Col span={12}>
              {comptes && grandLivre && (
                <FloatLabel
                  label="Compte centralisateur"
                  name="compteCentralisateur"
                  value={compteCentralisateur}
                >
                  <Form.Item name="compte_centralisateur">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="label"
                      optionLabelProp="label"
                      onChange={(value) => this.onChangeCompteCentralisateur(value)}
                    >
                      <OptGroup label="Compte">
                        {comptes.data &&
                          comptes.data
                            .filter((item) => item.compte_type_compte === "C")
                            .map((item, i) => (
                              <Option
                                key={i}
                                value={item.compte_id}
                                label={`${item.compte_compte_general} - ${item.compte_libelle}`}
                              >
                                <Row>
                                  <Col
                                    sm={8}
                                  >{`${item.compte_compte_general} - ${item.compte_libelle}`}</Col>
                                </Row>
                              </Option>
                            ))}
                      </OptGroup>
                    </Select>
                  </Form.Item>
                </FloatLabel>
              )}

              <Row gutter={12}>
                <Col span={12}>
                  {comptes && (
                    <FloatLabel label="Compte" name="compteDu" value={compteDu}>
                      <Form.Item name="compteDu">
                        <Select
                          showSearch
                          optionFilterProp="label"
                          optionLabelProp="label"
                          onSelect={(value) => this.onSelectCompteDu(value)}
                        >
                          <OptGroup label="Compte">
                            {this.filterByCompte(comptes.data, compteCentralisateur).map(
                              (item, i) => (
                                <Option
                                  key={i}
                                  value={
                                    compteCentralisateur
                                      ? item.compte_compte_auxiliaire
                                      : item.compte_compte_general
                                  }
                                  label={`${
                                    compteCentralisateur
                                      ? item.compte_compte_auxiliaire
                                      : item.compte_compte_general
                                  } - ${item.compte_libelle}`}
                                >
                                  <Row>
                                    <Col sm={8}>{`${
                                      compteCentralisateur
                                        ? item.compte_compte_auxiliaire
                                        : item.compte_compte_general
                                    } - ${item.compte_libelle}`}</Col>
                                  </Row>
                                </Option>
                              )
                            )}
                          </OptGroup>
                        </Select>
                      </Form.Item>
                    </FloatLabel>
                  )}
                </Col>

                <Col span={12}>
                  {comptes && grandLivre && (
                    <FloatLabel label="Au compte" name="compteAu" value={compteAu}>
                      <Form.Item name="compteAu">
                        <Select
                          showSearch
                          optionFilterProp="label"
                          optionLabelProp="label"
                          onSelect={(value) => this.onSelectCompteAu(value)}
                        >
                          <OptGroup label="Compte">
                            {this.filterByCompte(comptes.data, compteCentralisateur).map(
                              (item, i) => (
                                <Option
                                  key={i}
                                  value={
                                    compteCentralisateur
                                      ? item.compte_compte_auxiliaire
                                      : item.compte_compte_general
                                  }
                                  label={`${
                                    compteCentralisateur
                                      ? item.compte_compte_auxiliaire
                                      : item.compte_compte_general
                                  } - ${item.compte_libelle}`}
                                >
                                  <Row>
                                    <Col sm={8}>{`${
                                      compteCentralisateur
                                        ? item.compte_compte_auxiliaire
                                        : item.compte_compte_general
                                    } - ${item.compte_libelle}`}</Col>
                                  </Row>
                                </Option>
                              )
                            )}
                          </OptGroup>
                        </Select>
                      </Form.Item>
                    </FloatLabel>
                  )}
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              {/* Mêmes enveloppes que les sélecteurs de gauche (FloatLabel + Form.Item) : le tri s'aligne sur Compte / Au compte */}
              <div className="float-label">
                <Form.Item>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
                    <Button>
                      <CSVLink
                        filename={"export.csv"}
                        data={lignesEcritures}
                        headers={headers()}
                        separator={";"}
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => (grandLivre ? this.createPdf() : this.createPdf2())}
                    >
                      Impression comptes
                    </Button>
                  </div>
                </Form.Item>
              </div>
              {grandLivre && (
                <Form.Item>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Radio.Group onChange={(e) => this.onChangeTri(e)} value={tri}>
                      <Radio value={1}>tri alphanumérique</Radio>
                      <Radio value={2}>tri alphabétique</Radio>
                    </Radio.Group>
                  </div>
                </Form.Item>
              )}
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={6}>
              <FloatLabel label="Du" name="dateDu" value={dateDu}>
                <Form.Item name="date_du">
                  {/* Borné à l'exercice : garantit que « Du » ne précède pas la période chargée (report API) */}
                  <DatePicker
                    format={dateFormat}
                    placeholder=""
                    minDate={dayjs(`${annee}-01-01`)}
                    onChange={(e) => this.onChangeDateDu(e)}
                  />
                </Form.Item>
              </FloatLabel>
            </Col>
            <Col span={6}>
              <FloatLabel label="Au" name="dateAu" value={dateAu}>
                <Form.Item name="date_au">
                  {/* Borné à la fin de l'exercice (31/12 de l'année + 1), fin de la période chargée */}
                  <DatePicker
                    defaultValue={dayjs()}
                    format={dateFormat}
                    placeholder=""
                    maxDate={dayjs(`${annee + 1}-12-31`)}
                    onChange={(e) => this.onChangeDateAu(e)}
                  />
                </Form.Item>
              </FloatLabel>
            </Col>
            <Col span={2}>
              <RedoOutlined onClick={this.onRefresh} spin={refresh} style={{ fontSize: "32px" }} />
            </Col>
            <Col span={10}>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
                <FormItem name="soldeEvolutif" valuePropName="checked">
                  <Checkbox onChange={this.onChangeSoldeEvolutif}>Solde évolutif</Checkbox>
                </FormItem>
                <FormItem name="ecrituresPointees" valuePropName="checked">
                  <Checkbox onChange={this.onChangeEcrituresPointees}>Écritures pointées</Checkbox>
                </FormItem>
              </div>
            </Col>
          </Row>
        </Form>

        <VirtualTable
          className="table-ecritures"
          columns={columns}
          dataSource={lignesEcritures}
          onChange={this.handleChange}
          rowKey="ecriture_ligne_id"
          scroll={{
            y: 600,
            x: "100vw",
          }}
          scrollToBottom={true}
          scrollVersion={scrollVersion} // Nouvelle prop pour contrôler le scroll
          summary={(pageData) => {
            let totalDebit = 0;
            let totalCredit = 0;
            let solde = 0;

            pageData.forEach(({ ecriture_ligne_montant_debit, ecriture_ligne_montant_credit }) => {
              totalDebit += parseFloat(ecriture_ligne_montant_debit);
              totalCredit += parseFloat(ecriture_ligne_montant_credit);
            });

            solde = parseFloat(totalDebit - totalCredit);

            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <strong>TOTAL :</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text style={{ float: "right" }}>
                      <strong>
                        {parseFloat(totalDebit).toLocaleString("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        })}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text style={{ float: "right" }}>
                      <strong>
                        {parseFloat(totalCredit).toLocaleString("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        })}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
                <Table.Summary.Row>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <strong>SOLDE :</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text style={{ float: "right" }}>
                      <strong>
                        {solde >= 0 ? (
                          parseFloat(Math.abs(solde)).toLocaleString("fr-FR", {
                            style: "currency",
                            currency: "EUR",
                          })
                        ) : (
                          <></>
                        )}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text style={{ float: "right" }}>
                      <strong>
                        {solde <= 0 ? (
                          parseFloat(Math.abs(solde)).toLocaleString("fr-FR", {
                            style: "currency",
                            currency: "EUR",
                          })
                        ) : (
                          <></>
                        )}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      </Spin>
    );
  }
}

export default FormGrandLivre;